import Prize1 from '@/partners/lingo/lingo-giveaway/assets/images/prizes/prize_iphone.png'
import Prize2 from '@/partners/lingo/lingo-giveaway/assets/images/prizes/gift-card_starbucks.png'
import Prize3 from '@/partners/lingo/lingo-giveaway/assets/images/prizes/gift-card_Xbox.png'
import Prize4 from '@/partners/lingo/lingo-giveaway/assets/images/prizes/gift-card_handm.png'
import Prize5 from '@/partners/lingo/lingo-giveaway/assets/images/prizes/gift-card_ikea.png'
import Prize6 from '@/partners/lingo/lingo-giveaway/assets/images/prizes/gift-card_nike.png'
import Prize7 from '@/partners/lingo/lingo-giveaway/assets/images/prizes/gift-card_sephora.png'
import Prize8 from '@/partners/lingo/lingo-giveaway/assets/images/prizes/travala.png'
import Prize9 from '@/partners/lingo/lingo-giveaway/assets/images/prizes/prize_y00t.png'
import Prize10 from '@/partners/lingo/lingo-giveaway/assets/images/prizes/gift-card_decathlon.png'
import Prize11 from '@/partners/lingo/lingo-giveaway/assets/images/prizes/prize_beanz.png'
import Prize12 from '@/partners/lingo/lingo-giveaway/assets/images/prizes/gift-card_steam.png'
import Prize13 from '@/partners/lingo/lingo-giveaway/assets/images/prizes/persona.png'
import Prize14 from '@/partners/lingo/lingo-giveaway/assets/images/prizes/gift-card_nintendo.png'
import Prize15 from '@/partners/lingo/lingo-giveaway/assets/images/prizes/gift-card_sony.png'
import Prize16 from '@/partners/lingo/lingo-giveaway/assets/images/prizes/prize_chimpers.png'

import type { Prize } from '@/partners/lingo/lingo-giveaway/types/giveaway'

export enum PrizeKeys {
  IPHONE = 'iphone',
  FIZEN_NIKE = 'fizen_nike',
  TRAVALA_GIFT_CARDS = 'travala_gift_cards',
  FIZEN_HM = 'fizen_hm',
  CHIMPERS = 'chimpers',
  FIZEN_IKEA = 'fizen_ikea',
  FIZEN_SONY = 'fizen_sony',
  FIZEN_SEPHORA = 'fizen_sephora',
  FIZEN_NINTENDO = 'fizen_nintendo',
  FIZEN_XBOX = 'fizen_xbox',
  BEANS = 'beans',
  FIZEN_STARBUCKS = 'fizen_starbucks',
  FIZEN_DECATHLON = 'fizen_decathlon',
  Y00TS = 'y00ts',
  FIZEN_STEAM = 'fizen_steam',
  PERSONA = 'persona',
}

export const prizes: Record<PrizeKeys, Prize> = {
  [PrizeKeys.IPHONE]: {
    name: 'IPhone',
    src: Prize1,
  },
  [PrizeKeys.FIZEN_STARBUCKS]: {
    name: 'Fizen - Starbucks',
    src: Prize2,
  },
  [PrizeKeys.FIZEN_XBOX]: {
    name: 'Fizen - Xbox',
    src: Prize3,
  },
  [PrizeKeys.FIZEN_HM]: {
    name: 'Fizen - H&M',
    src: Prize4,
  },
  [PrizeKeys.FIZEN_IKEA]: {
    name: 'Fizen - IKEA',
    src: Prize5,
  },
  [PrizeKeys.FIZEN_NIKE]: {
    name: 'Fizen - Nike',
    src: Prize6,
  },
  [PrizeKeys.FIZEN_SEPHORA]: {
    name: 'Fizen - Sephora',
    src: Prize7,
  },
  [PrizeKeys.TRAVALA_GIFT_CARDS]: {
    name: 'Travala',
    src: Prize8,
  },
  [PrizeKeys.Y00TS]: {
    name: 'Y00TS',
    src: Prize9,
  },
  [PrizeKeys.FIZEN_DECATHLON]: {
    name: 'Fizen - Decathlon',
    src: Prize10,
  },
  [PrizeKeys.BEANS]: {
    name: 'Beans',
    src: Prize11,
  },
  [PrizeKeys.FIZEN_STEAM]: {
    name: 'Fizen - Steam',
    src: Prize12,
  },
  [PrizeKeys.PERSONA]: {
    name: 'Persona',
    src: Prize13,
  },
  [PrizeKeys.FIZEN_NINTENDO]: {
    name: 'Fizen- Nintendo',
    src: Prize14,
  },
  [PrizeKeys.FIZEN_SONY]: {
    name: 'Fizen - Sony',
    src: Prize15,
  },
  [PrizeKeys.CHIMPERS]: {
    name: 'Chimpers',
    src: Prize16,
  },
}

export const prizeSchedule: Record<number, PrizeKeys> = {
  1: PrizeKeys.IPHONE,
  2: PrizeKeys.FIZEN_NIKE,
  3: PrizeKeys.TRAVALA_GIFT_CARDS,
  4: PrizeKeys.FIZEN_HM,
  5: PrizeKeys.CHIMPERS,
  6: PrizeKeys.FIZEN_IKEA,
  7: PrizeKeys.FIZEN_SONY,
  8: PrizeKeys.FIZEN_SEPHORA,
  9: PrizeKeys.IPHONE,
  10: PrizeKeys.FIZEN_NINTENDO,
  11: PrizeKeys.TRAVALA_GIFT_CARDS,
  12: PrizeKeys.FIZEN_XBOX,
  13: PrizeKeys.BEANS,
  14: PrizeKeys.IPHONE,
  15: PrizeKeys.FIZEN_STARBUCKS,
  16: PrizeKeys.TRAVALA_GIFT_CARDS,
  17: PrizeKeys.FIZEN_DECATHLON,
  18: PrizeKeys.Y00TS,
  19: PrizeKeys.FIZEN_STEAM,
  20: PrizeKeys.TRAVALA_GIFT_CARDS,
  21: PrizeKeys.FIZEN_NIKE,
  22: PrizeKeys.PERSONA,
  23: PrizeKeys.IPHONE,
  24: PrizeKeys.FIZEN_NIKE,
  25: PrizeKeys.TRAVALA_GIFT_CARDS,
  26: PrizeKeys.FIZEN_HM,
  27: PrizeKeys.IPHONE,
  28: PrizeKeys.FIZEN_SONY,
  29: PrizeKeys.TRAVALA_GIFT_CARDS,
  30: PrizeKeys.FIZEN_STEAM,
  31: PrizeKeys.FIZEN_HM,
  32: PrizeKeys.IPHONE,
  33: PrizeKeys.TRAVALA_GIFT_CARDS,
  34: PrizeKeys.FIZEN_SONY,
  35: PrizeKeys.FIZEN_STEAM,
  36: PrizeKeys.TRAVALA_GIFT_CARDS,
  37: PrizeKeys.IPHONE,
  38: PrizeKeys.FIZEN_NIKE,
  39: PrizeKeys.FIZEN_HM,
  40: PrizeKeys.IPHONE,
  41: PrizeKeys.TRAVALA_GIFT_CARDS,
  42: PrizeKeys.FIZEN_SONY,
  43: PrizeKeys.FIZEN_STEAM,
  44: PrizeKeys.TRAVALA_GIFT_CARDS,
  45: PrizeKeys.IPHONE,
  46: PrizeKeys.FIZEN_NIKE,
  47: PrizeKeys.TRAVALA_GIFT_CARDS,
  48: PrizeKeys.FIZEN_NINTENDO,
  49: PrizeKeys.FIZEN_SONY,
  50: PrizeKeys.IPHONE,
  51: PrizeKeys.IPHONE,
}